import React from 'react';
import styled, { css } from 'styled-components';
import { Text, TextVariant } from '@naf/text';
import { spacing, radius, themeLight } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Check } from '@styled-icons/material/Check';
import { Add } from '@styled-icons/material/Add';
import { propValidationConfig } from '../propValidationConfig';
export const MemberLabel = ({
  labelText = 'NAF-Medlem',
  isEligible = false,
  inverted = false,
  className
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(IconContainer, {
    $isEligible: isEligible
  }, isEligible ? /*#__PURE__*/React.createElement(Check, {
    size: 16
  }) : /*#__PURE__*/React.createElement(Add, {
    size: 16
  })), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(StyledText, {
    $inverted: inverted,
    variant: TextVariant.TagSmall
  }, labelText)));
};
export default MemberLabel;
export const Container = styled.div.withConfig({
  displayName: "memberLabel__Container",
  componentId: "sc-mhs4db-0"
})(["max-width:400px;display:flex;align-items:center;"]);
export const IconContainer = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "memberLabel__IconContainer",
  componentId: "sc-mhs4db-1"
})(["border-radius:", ";width:20px;height:20px;display:flex;justify-content:center;align-items:center;color:", ";background-color:", ";"], radius.s, nafColor.signature.black, ({
  $isEligible
}) => $isEligible ? nafColor.primary.kart : nafColor.signature.yellow);
export const TextContainer = styled.div.withConfig({
  displayName: "memberLabel__TextContainer",
  componentId: "sc-mhs4db-2"
})(["display:flex;align-items:center;margin-left:", ";padding:3px 4px;border:1px solid ", ";border-radius:", ";"], spacing.space4, themeLight.border.default, radius.s);
export const StyledText = styled(Text).withConfig({
  displayName: "memberLabel__StyledText",
  componentId: "sc-mhs4db-3"
})(["", ""], ({
  $inverted
}) => $inverted && css(["color:", ";"], nafColor.signature.white));
//# sourceMappingURL=memberLabel.js.map